<template>
  <v-container class="py-7">
    <v-row>
      <v-col cols="12">
        <div class="title-container">
          <div class="title-block">
            <span class="page-title">Cargos e permissões</span>
            <v-breadcrumbs class="app-breadcrumb" divider="›" :items="breadcrumbs"></v-breadcrumbs>
          </div>
          <div class="button-group">
            <v-btn v-if="$check('Role', 'POST')" color="primary" elevation="0" to="/cargos/novo">Incluir</v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card class="filter-card">
          <v-card-title class="filter-card-title">Filtro</v-card-title>
          <v-card-text>
            <v-form @submit.prevent="load">
              <v-row>
                <v-col cols="12" md="10">
                  <v-text-field dense label="Nome" v-model="filter.name" outlined hide-details></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-btn block color="primary" type="submit" elevation="2">Filtrar</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card class="table-card">
          <v-data-table
            :headers="headers"
            :items="items"
            :server-items-length="count"
            :loading="loading"
            :disable-sort="true"
            :options.sync="options"
            :footer-props="footerOptions"
            class="app-table hover-table"
            no-data-text="Nenhum cargo foi encontrado"
            loading-text="Carregando dados..."
            @update:items-per-page="pageSizeChanged"
            @update:page="pageChanged"
          >
            <template v-slot:[`item.is_system`]="{ item }">
              <v-chip small label :color="item.is_system ? 'primary' : undefined" :text-color="item.is_system ? 'white' : undefined">
                {{ item.is_system ? 'Sistema' : 'Personalizado' }}
              </v-chip>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-icon v-if="$check('Role', 'PATCH')" @click="viewItem(item)" size="large" class="me-2">
                mdi-pencil-outline
              </v-icon>
              <v-icon v-if="$check('Role', 'DELETE') && !item.is_system" @click="remove(item)" size="large">
                mdi-delete-outline
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "RoleList",

  data: () => ({
    breadcrumbs: [
      { text: "Homepage", disabled: false, to: "/home", exact: true },
      { text: "Cargos e permissões", disabled: true, exact: true },
    ],
    filter: {
      name: "",
    },
    headers: [
      { text: "Nome", value: "name" },
      { text: "Descrição", value: "description" },
      { text: "Tipo", value: "is_system" },
      { text: "Ações", value: "actions", sortable: false },
    ],
    items: [],
    loading: false,
    count: 0,
    options: {
      page: 1,
      size: 10,
    },
    footerOptions: {
      itemsPerPageText: "Itens por página:",
      itemsPerPageOptions: [10, 20, 30, 40, 50],
      pageText: "{0}-{1} de {2}",
    },
  }),

  created() {
    this.load();
  },

  methods: {
    async load() {
      this.loading = true;

      try {
        const search = this.filter.name ? { name: this.filter.name } : null;
        const result = await axios.get("/api/v1/roles", {
          params: {
            page: this.options.page,
            limit: this.options.size,
            search,
          },
        });

        this.items = result.data.content.data;
        this.count = result.data.content.paging.total;
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 3000 });
      } finally {
        this.loading = false;
      }
    },

    pageChanged(page) {
      this.options.page = page;
      this.load();
    },

    pageSizeChanged(size) {
      this.options.size = size;
      this.load();
    },

    viewItem(item) {
      this.$router.push(`/cargos/${item.id}`);
    },

    async remove(item) {
      const proceed = await this.$dialog.confirm({
        title: "Excluir cargo",
        text: "Deseja excluir este cargo?",
        actions: { false: "Cancelar", true: "Excluir" },
      });

      if (!proceed) return;

      try {
        await axios.delete(`/api/v1/roles/${item.id}`);
        this.$dialog.notify.info("Cargo excluído com sucesso", { position: "top-right", timeout: 2000 });
        this.load();
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 3000 });
      }
    },
  },
};
</script>
